<template>
  <div id="app">
    <header-component></header-component>
    <section id="layout-content">
      <div class="container">
        <map-component></map-component>
        <div style="text-align: center; margin: 100px 0">
          <h1>Zobacz pełną ofertę!</h1>
          <a href="https://www.parkerpen.com" class="button" style="display: inline-block; text-decoration: none; line-height: 44px; font-weight: 300;">SPRAWDŹ</a>
        </div>
        <div class="pictures" style="display: flex; flex-wrap: wrap;">
          <div style="display: flex; flex-wrap: wrap;">
            <div class="image-box" style="width: calc(7.05 / 11 * 100%);">
              <img src="./assets/images/product-1.png" alt="produkt">
            </div>
            <div style="display: flex; flex-wrap: wrap; width: calc(3.95 / 11 * 100%);">
              <div class="image-box" style="width: 100%">
                <img src="./assets/images/product-2.png" alt="produkt">
              </div>
              <div class="image-box" style="width: 50%;">
                <img src="./assets/images/product-3.png" alt="produkt">
              </div>
              <div class="image-box" style="width: 50%;">
                <img src="./assets/images/product-4.png" alt="produkt">
              </div>
            </div>
          </div>
          <div style="display: flex; width: 100%;">
            <div class="image-box" style="width: 42.7%;">
              <img src="./assets/images/product-5.png" alt="produkt">
            </div>
            <div class="image-box" style="width: 57.3%;">
              <img src="./assets/images/product-6.png" alt="produkt">
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer-component></footer-component>
    <cookie-law theme="parker">
      <div class="Cookie--parker__wrapper" slot-scope="props">
        <div class="Cookie--parker__wrapper__text">
          <p>
            Ta strona korzysta z różnych rodzajów plików cookie, aby umożliwić, ulepszyć i monitorować korzystanie z naszej witryny. Aby uzyskać więcej informacji, zapoznaj się z naszą polityką dotyczącą plików cookie. Klikając przycisk akceptuj lub kontynuując przeglądanie naszej witryny, wyrażasz zgodę na korzystanie z urządzenia analitycznego, reklamy i inne tagi / pliki.
          </p>
        </div>
        <div class="Cookie--parker__wrapper__buttons">
          <button class="Cookie__button Cookie__button--accept" @click="props.accept"><span>Akceptuję ciasteczka od tej strony</span></button>
          <a href="https://privacy.newellbrands.com/cookie_pl.html" class="Cookie__button"><span>Polityka prywatności</span></a>
        </div>
      </div>
    </cookie-law>
  </div>
</template>

<script>
import HeaderComponent from "./components/HeaderComponent";
import MapComponent from "./components/MapComponent";
import FooterComponent from "./components/FooterComponent";
import CookieLaw from "vue-cookie-law"
export default {
  name: 'app',
  components: {
    FooterComponent,
    MapComponent,
    HeaderComponent,
    CookieLaw
  }
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Roboto:300&display=swap');
  @import '~@csstools/normalize.css';
  @import "~simplebar";
  @font-face {
    font-family: 'Gotham';
    src: url('./assets/fonts/gotham-medium/Gotham-Medium.eot');
    src: url('./assets/fonts/gotham-medium/Gotham-Medium.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/gotham-medium/Gotham-Medium.woff2') format('woff2'),
    url('./assets/fonts/gotham-medium/Gotham-Medium.woff') format('woff'),
    url('./assets/fonts/gotham-medium/Gotham-Medium.ttf') format('truetype'),
    url('./assets/fonts/gotham-medium/Gotham-Medium.svg#Gotham-Medium') format('svg');
    font-weight: 500;
    font-style: normal;
  }
  $primary : #000000FF;
  $secondary: #B7A364;
  $bg-color: #fff;
  body{
    margin: 0;
    font-family: Gotham, sans-serif;
    background-color: $bg-color;
    color: $primary;
  }
  .container{
    width: 1100px;
    max-width: 100%;
    margin:auto;
  }
  .container-fluid{
    width: 100%;
    background-color: $bg-color;
  }
  .button{
    font-size: 18px;
    margin: 5px;
    background: $primary;
    border-radius: 5px;
    border: none;
    height: 44px;
    color: white;
    font-weight: bold;
    padding: 0 40px;
    width: 240px;
    max-width: 30%;
    cursor: pointer;
  }
  .input {
    box-sizing: border-box;
    font-family: "Roboto", sans-serif;
    font-weight: 300;
    margin: 10px;
    background: transparent;
    border-radius: 5px;
    text-align: center;
    font-size: 18px;
    height: 44px;
    padding: 0 5px;
    width: 240px;
    max-width: 30%;
  }
  .image-box{
    box-sizing: border-box;
    padding: 8px;
    img{
      vertical-align: bottom;
      width: 100%;
    }
  }
  .simplebar-scrollbar:before{
    background: $primary !important;
  }
  .simplebar-track .simplebar-scrollbar.simplebar-visible:before {
    opacity: 1 !important;
  }
  .Cookie--parker {
    width: 100%;
    box-sizing: border-box;
    box-shadow: 0 0 6px rgba(0, 0, 0, .4);
    background: $bg-color;
    color: $primary;
    padding: 10px;
    &__wrapper{
      display: flex;
      justify-content: space-between;
      align-items: center;
      &__buttons{
        display: flex;
        flex-direction: column;
      }
    }
    .Cookie__button {
      box-sizing: border-box;
      justify-self: stretch;
      text-decoration: none;
      margin: 2px 0;
      font-weight: bold;
      background: $secondary;
      padding: 0.625em;
      color: $bg-color;
      border-radius: 10px;
      border: 0;
      font-size: .9em;
      &:hover {
        background: darken($secondary, 3%);
      }
    }
  }
  @media (max-width: 992px) {
    .Cookie--parker {
      &__wrapper{
        width: 100%;
        flex-direction: column;
        justify-content: center;
      }
    }
    .Cookie__button {
      font-size: .9em;
    }
  }
</style>
